import { useApp } from '../context/AppContext.jsx';

export function useGuide() {
  const { guide, setGuide, updateGuide } = useApp();
  return { guide, setGuide, updateGuide };
}
